import $ from 'jquery';
import 'chosen-js';

$('.chosen-select').chosen();
